import {Graphics, Sprite} from 'pixi.js';
import {SizesSelectorButton} from './sizes_selector/SizesSelectorButton';
import {StaticData} from '../../../../../../data/StaticData';
import {SizesSelectorButtonEvents} from './sizes_selector/SizesSelectorButtonEvents';
import {Back, gsap} from 'gsap';

export class SizesSelector extends Sprite
{
    private hoverBg: Graphics;
    private buttons: SizesSelectorButton[] = [];
    private onSizesButtonSelectedBindThis: (e: Event) => void;
    private appearPivotTween: gsap.core.Tween | undefined;
    private appearAlphaTween: gsap.core.Tween | undefined;

    constructor(private playerId: string) {
        super();

        this.hoverBg = new Graphics();
        this.hoverBg.beginFill(0x0, .001);
        this.hoverBg.drawRoundedRect(
            -StaticData.videoSeatScalesButtonSize / 2,
            -StaticData.videoSeatScalesButtonSize / 2,
            StaticData.videoSeatScales.length * 50 - 6,
            StaticData.videoSeatScalesButtonSize + 20,
            9
        );
        this.hoverBg.endFill();
        this.addChild(this.hoverBg);

        let button: SizesSelectorButton;
        StaticData.videoSeatScales.forEach((scale: number, index: number) => {
            button = new SizesSelectorButton(playerId, index);
            button.x = index * 50;
            this.addChild(button);
            this.buttons.push(button);
        });
        button!.selected = true;

        this.onSizesButtonSelectedBindThis = this.onSizesButtonSelected.bind(this);
        addEventListener(SizesSelectorButtonEvents.SELECTED, this.onSizesButtonSelectedBindThis);

        this.interactive = this.interactiveChildren = true;
        this.pivot.y = -50;
        this.alpha = 0;
    }

    destroy(): void {
        let button: SizesSelectorButton;
        while (this.buttons.length) {
            button = this.buttons.shift()!;
            this.removeChild(button);
            button.destroy();
        }

        removeEventListener(SizesSelectorButtonEvents.SELECTED, this.onSizesButtonSelectedBindThis);
        delete this.onSizesButtonSelectedBindThis;

        super.destroy({children: true});
    }

    appear(value: boolean = true): void {
        this.appearPivotTween && this.appearPivotTween.pause();
        this.appearAlphaTween && this.appearAlphaTween.pause();
        this.appearPivotTween = gsap.to(this.pivot, {
            y: value ? 0 : -50,
            duration: .3,
            ease: value ? Back.easeOut : Back.easeIn
        });
        this.appearAlphaTween = gsap.to(this, {
            alpha: value ? 1 : 0,
            duration: .3,
            ease: value ? Back.easeOut : Back.easeIn
        });
    }

    private onSizesButtonSelected(e: Event): void {
        let data: {playerId: string, index: number} = (e as MessageEvent).data;
        if (data.playerId != this.playerId) {
            return;
        }
        this.buttons.forEach(button => {
            button.selected = button.index == data.index;
        });
    }
}
